import {
    Configuration,
    ConfigurationParameters,
    EventApi,
    ArticlesApi,
    ShowApi,
    DebugApi,
    EpisodeApi,
    ProjectsApi,
    FilesApi,
} from './rest';

class APIConfig {
    public config;
    constructor() {
        this.config = new Configuration({
            basePath: process.env.REACT_APP_API_BASE_URL,
            headers: {
                'Access-Control-Allow-Origin': '*',
            },
        });
    }
    setConfig(configuration: ConfigurationParameters) {
        this.config = new Configuration({
            basePath: process.env.REACT_APP_API_BASE_URL,
            headers: {
                'Access-Control-Allow-Origin': '*',
            },
            ...configuration,
        });
        EventAPI = new EventApi(this.config);
        ArticleApi = new ArticlesApi(this.config);
        ShowsApi = new ShowApi(this.config);
        OtherApi = new DebugApi(this.config);
        EpisodesApi = new EpisodeApi(this.config);
        ProjectApi = new ProjectsApi(this.config);
        FileApi = new FilesApi(this.config);
    }
}

export const configuration = new APIConfig();
export let EventAPI = new EventApi(configuration.config);
export let ArticleApi = new ArticlesApi(configuration.config);
export let ShowsApi = new ShowApi(configuration.config);
export let EpisodesApi = new EpisodeApi(configuration.config);
export let OtherApi = new DebugApi(configuration.config);
export let ProjectApi = new ProjectsApi(configuration.config);
export let FileApi = new FilesApi(configuration.config);
